import classNames from 'classnames';

import {useI18n} from '@udemy/i18n';

import {TopicCard} from './topic-card.react-component';
import styles from './topic-links.module.less';
import {TopicLinksProps} from './types';

export const TopicLinks = ({topics}: TopicLinksProps) => {
    const {gettext} = useI18n();

    if (!topics || topics.length === 0) return null;

    return (
        <div className={classNames('ud-container')}>
            <div className={classNames(styles['topic-links-wrapper'])}>
                <h2 className={classNames('ud-heading-xl', styles['topic-heading'])}>
                    {gettext('Learn the skills that matter most')}
                </h2>
                <div className={styles['topic-links-container']}>
                    {topics?.map((topic) => <TopicCard {...topic} key={topic.id} />)}
                </div>
            </div>
        </div>
    );
};
